import { FormNames, IFormDefinition } from 'models/Form/FormModels'
import { extendedInfoFields } from './ExtendedInfoFields'
import { AppLinks } from 'enviroment/AppLinks'

export const extendedInfoForm: IFormDefinition = {
   name: FormNames.ExtendedInfoForm,
   fields: extendedInfoFields,
   labelTextContentPath: "extendedInfoFormPage.label",
   urlPath: AppLinks.extendedInfoForm,
   previousStepUrlPath: AppLinks.addressInfoForm,
   canStepBack: true,
   subbmitButtonTextContentPath: "extendedInfoFormPage.subbmitButtonText"
}